// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3iNAk","productName":"Table_productName__1R6wV"};